<span class="wrapper">
  <span class="bar"></span>
</span>
